import * as React from 'react';
import { Id } from '../../utils/ids.js';
import { Bem, addClass } from '../../utils/css.js';
import { printDevError } from '../../utils/common.js';
import { RadioGroupContextConsumer } from './RadioGroupContext.js';
import './RadioButton.scss.js';

const bem = Bem.create("vai-radio-button");
const _RadioButton = class extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.label = React.createRef();
    this.state = { focused: false };
    this.renderWithContext = (context) => {
      const {
        label,
        state: { focused },
        props: { htmlId, className, dataTa, disabled, children, onChange: propsOnChange, value, ...rest }
      } = this;
      const id = Id.create(htmlId, ["radio button"]);
      const checked = _RadioButton.isChecked(context, this.props);
      const onChange = propsOnChange || context.onChange;
      return /* @__PURE__ */ React.createElement("div", {
        id: id.toString(),
        "data-ta": dataTa,
        className: addClass(bem.block(), className)
      }, /* @__PURE__ */ React.createElement("label", {
        className: bem.element("label")(checked && "checked", disabled && "disabled", focused && "focused"),
        ref: label,
        tabIndex: -1,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }, /* @__PURE__ */ React.createElement(_RadioButton.Thumb, null), /* @__PURE__ */ React.createElement("input", {
        ...rest,
        id: id.copyWith(["input"]).toString(),
        className: bem.element("input")(checked && "checked", disabled && "disabled"),
        type: "radio",
        disabled,
        onChange,
        tabIndex: checked && !disabled ? 0 : -1,
        value,
        checked
      }), children));
    };
    this.onFocus = () => this.setState({ focused: true });
    this.onBlur = (event) => {
      const { current } = this.label;
      try {
        if (!current.contains(event.relatedTarget)) {
          this.setState({ focused: false });
        }
      } catch (e) {
        printDevError(`RadioButton onBlur error: ${e?.toString()}
            This is probably caused by a bug in @vaisala-rockhopper/components library`);
      }
    };
  }
  render() {
    return /* @__PURE__ */ React.createElement(RadioGroupContextConsumer, null, this.renderWithContext);
  }
  static isChecked(context, props) {
    return context.value !== void 0 && context.value === props.value || !!props.checked;
  }
};
let RadioButton = _RadioButton;
RadioButton.metaProperties = ["disabled"];
RadioButton.Thumb = () => /* @__PURE__ */ React.createElement("svg", {
  className: "vai-radio-thump",
  height: "15",
  width: "15",
  tabIndex: -1,
  key: Math.random()
}, /* @__PURE__ */ React.createElement("circle", {
  cx: "7.5",
  cy: "7.5",
  r: "7",
  className: "vai-radio-thump__outer"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: "7.5",
  cy: "7.5",
  r: "4",
  className: "vai-radio-thump__inner"
}));

export { RadioButton };
